<div class="container">
  <div class="d-flex justify-content-center align-items-center footer-area">
    <a class="footer-brand" href="{{ env?.siteUrl }}"><img src="/assets/images/footer-logo.png" alt="logo" /></a>
    <span class="ml-4 copyRightText">{{ "page.footer" | translate : { year: "2024" } }}</span>
  </div>
</div>
